import EnumType from "@/app/shared/EnumType.js";

const destinationTypes = {
  RemuckBay: 1,
  OrePass: 2,
  Truck: 3,
  StockPile: 4
};

export default EnumType.generate(destinationTypes, "GradeControl.DestinationType.");